
    import { Component } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import PageRequest from '@/store/entities/page-request';
    import ListView from '@/components/helper/list-view.vue';
    import FormBase from '@/components/helper/form-base.vue';
    import EmployeeForm from './employee-form.vue';

    class PageEmployeeRequest extends PageRequest {
        dealer: number = null;
        search: string = '';
    }

    @Component({
        components: { ListView, EmployeeForm, FormBase }
    })
    export default class Employees extends ListBase {
        entity: string = 'employee';
        filterForm: boolean = true;
        pagerequest: PageEmployeeRequest = new PageEmployeeRequest();

        filterItems = [
            this.gItem({ type: 'object', prop: 'dealer', label: 'Concesionario', itemText: 'fullname', hideDetails: true, onchange: this.afterSave, size: 4 }),
            this.gItem({ type: 'text', prop: 'search', label: 'Buscar por Nombre o Codigo', hideDetails: true, onchange: this.afterSave, size: 4 }),
            this.gItem({ type: 'spacer', size: 4 }),
        ]

        columns = [
            this.gCol('code', 'Documento', 'text'),
            this.gCol('fullname', 'Nombre Completo', 'text'),
            this.gCol('email', 'Email', 'text'),
            this.gCol('active', 'Habilitado', 'text'),
            this.defaultActions()
        ]

        edit() {
            this.modalShow = !this.modalShow;
        }
        create() {
            this.modalShow = !this.modalShow;
        }
        async afterSave() {
            let list: any = this.$refs.listView
            await list.getpage();
        }

        mounted() {
        }

        created() {
        }
    }
